import React, { Component } from 'react';

import style from './Hamburger.module.scss';

class Hamburger extends Component {
  handleChange = e => {
    if (window.innerWidth >= 1200) {
      this.props.toggleDesktopMenu();
    } else {
      this.props.handleMobileMenu();
    }
  };

  render() {
    const {
      isMenuCollapsed,
      isMobileMenuOpen,
      mainNavColor,
      menuCollapsedPage,
      menuToggledOpen,
    } = this.props;

    return (
      <button
        className={`
          ${menuCollapsedPage ? style.activeHamburger : ''}
          ${style.hamburger}
          ${isMobileMenuOpen || menuToggledOpen ? style.hamburgerOpen : ''}
          ${mainNavColor === 'white' ? style.whiteHamburger : ''}
          `}
        onClick={this.handleChange}
      >
        <div className={style.hamburgerWrapper}>
          <div className={`${style.bar} ${style.barTop} ${style.barLeft}`} />
          <div className={`${style.bar} ${style.barTop} ${style.barRight}`} />
          <div className={`${style.barMiddle}`}>Menu</div>
          <div className={`${style.bar} ${style.barBottom} ${style.barLeft}`} />
          <div
            className={`${style.bar} ${style.barBottom} ${style.barRight}`}
          />
        </div>
      </button>
    );
  }
}

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/global/Hamburger.js